"use client";

import { usePathname } from "next/navigation";
import { ROUTES } from "@lib/routes";
import { AgentChatWidget } from "./AgentChatWidget";

/**
 * Keeps the floating tutor launcher off the first-run wizard, which owns its own
 * chrome. The widget runs several hooks, so it is gated here rather than with an
 * early return inside it (that would change the hook order across routes).
 */
export function AgentChatWidgetSlot() {
  const pathname = usePathname();
  if (pathname === ROUTES.onboarding) return null;
  return <AgentChatWidget />;
}
